function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ececec;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "738.26 431.61 674.46 431.61 638.2 431.61 621.9 431.61 587.04 431.61 781.48 147.16 783.79 143.82 784.34 143.01 813.73 100.08 777.67 100.08 748.28 143.01 747.74 143.82 747.6 143.82 536.76 451.81 536.76 452.43 530.64 461.41 536.76 461.41 566.56 461.41 618 461.41 839.04 461.41 896.66 461.41 896.66 501.89 839.04 501.89 702.6 501.89 702.6 531.69 839.04 531.69 926.46 531.69 926.46 431.61 839.04 431.61 738.26 431.61"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "931.22 0 471.38 0 471.38 100.08 689.5 100.08 449.34 451.81 449.34 531.69 536.76 531.69 668.35 531.69 668.35 501.89 536.76 501.89 479.14 501.89 479.14 461.07 725.69 100.08 746.03 70.28 501.18 70.28 501.18 29.8 911.02 29.8 659.5 400.24 695.75 400.24 947.08 29.8 967.28 0 931.22 0"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M83.74,687.54V703H0v-12.2l57.79-70.56H1V604.78H81.92V617L24.13,687.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M169.73,660.19V604.78H188v54.7c0,20.2,9.11,28.9,25,28.9s24.83-8.7,24.83-28.9v-54.7h18v55.41c0,28.61-16.13,44.18-42.93,44.18S169.73,688.8,169.73,660.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M441.58,703l-.14-65.09-32.26,53.87H401l-32.26-53V703H351.39V604.78h15l39,65.08,38.29-65.08h15l.14,98.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M619.17,680.24h-49.1L560.39,703H541.6l44.18-98.19h18L648.06,703H629Zm-6-14.3L594.62,623l-18.38,42.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M839.54,604.78h18.23v82.76h51.34V703H839.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1058.08,680.24H1009L999.31,703h-18.8l44.19-98.19h18L1087,703H1067.9Zm-6-14.3L1033.53,623l-18.37,42.93Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1256.85,676.32c0,16.83-13.19,26.65-38.44,26.65H1169.6V604.78h46c23.57,0,36.19,10,36.19,25.53,0,10.1-5,17.53-12.62,21.6C1249.7,655.28,1256.85,663.55,1256.85,676.32Zm-69-57.23v27.07h25.81c12.62,0,19.77-4.49,19.77-13.47s-7.15-13.6-19.77-13.6Zm50.63,55.4c0-9.82-7.43-14.16-21.18-14.16h-29.45v28.33h29.45C1231,688.66,1238.47,684.31,1238.47,674.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1338.21,692.59l6.31-14.17c7.86,6.31,20.34,10.8,32.4,10.8,15.29,0,21.75-5.47,21.75-12.76,0-21.18-58.36-7.3-58.36-43.77,0-15.85,12.63-29.31,39.56-29.31,11.78,0,24.13,3.08,32.68,8.69l-5.75,14.17a54.55,54.55,0,0,0-27.07-7.71c-15.15,0-21.32,5.89-21.32,13.32,0,20.9,58.21,7.3,58.21,43.35,0,15.71-12.76,29.17-39.7,29.17C1361.63,704.37,1346.34,699.6,1338.21,692.59Z"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1416.62 704.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1f38d661a74f0355713873bcfb720042.svg";
export { ForwardRef as ReactComponent };